import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { JobProvider } from './context/JobContext';
import { SessionLockProvider } from './context/SessionLockContext';
import { MaintenanceProvider } from './context/MaintenanceContext';
import MaintenanceGuard from './components/MaintenanceGuard';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Companies from './pages/Companies';
import Controparti from './pages/Controparti';
import Users from './pages/Users';
import Roles from './pages/Roles';
import Contacts from './pages/Contacts';
import ContactDetails from './pages/ContactDetails';
import Locations from './pages/Locations';
import StatiPratica from './pages/StatiPratica';
import TipiPratica from './pages/TipiPratica';
import TipiPraticaAzione from './pages/TipiPraticaAzione';
import PfTipiOperazione from './pages/PfTipiOperazione';
import PfStatiPratica from './pages/PfStatiPratica';
import PfTipiDocumento from './pages/PfTipiDocumento';
import PfIstitutiEroganti from './pages/PfIstitutiEroganti';
import PfClienti from './pages/PfClienti';
import PfPratiche from './pages/PfPratiche';
import PfPraticaNew from './pages/PfPraticaNew';
import PfPraticaEdit from './pages/PfPraticaEdit';
import PfPraticaDetail from './pages/PfPraticaDetail';
import PfPraticaDocumenti from './pages/PfPraticaDocumenti';
import TipiAtto from './pages/TipiAtto';
import TipiPosizioneCredito from './pages/TipiPosizioneCredito';
import TipiAllegatoUO from './pages/TipiAllegatoUO';
import TipiRapporto from './pages/TipiRapporto';
import TipiEvento from './pages/TipiEvento';
import FeeConfigs from './pages/FeeConfigs';
import FeeConfigForm from './pages/FeeConfigForm';
import Profile from './pages/Profile';
import NotFound from './pages/NotFound';
import QuoteWizard from './pages/QuoteWizard';
import QuotesList from './pages/QuotesList';
import EmailAccounts from './pages/EmailAccounts';
import JobsMonitor from './pages/JobsMonitor';
import DbMonitor from './pages/DbMonitor';
import EmailClient from './pages/EmailClient';
import Urgency from './pages/Urgency';
import Tribunali from './pages/Tribunali';
import Legali from './pages/Legali';
import EsitiUdienza from './pages/EsitiUdienza';
import CategoryNegotiation from './pages/CategoryNegotiation';
import CategoryNegotiationDetail from './pages/CategoryNegotiationDetail';
import Cluster from './pages/Cluster';
import ClusterDetail from './pages/ClusterDetail';
import Contatto from './pages/Contatto';
import DebitoGrant from './pages/DebitoGrant';
import DebitoRole from './pages/DebitoRole';
import Department from './pages/Department';
import Office from './pages/Office';
import AppDepartments from './pages/AppDepartments';
import AppOffices from './pages/AppOffices';
import LorenzoUsers from './pages/LorenzoUsers';
import Customer from './pages/Customer';
import CustomerDetail from './pages/CustomerDetail';
import CustomerCumulative from './pages/CustomerCumulative';
import RisorseApiPasspartout from './pages/RisorseApiPasspartout';
import PasspClientes from './pages/PasspClientes';
import PasspFatture from './pages/PasspFatture';
import PasspFattureStats from './pages/PasspFattureStats';
import PasspFattureVsPrimaNota from './pages/PasspFattureVsPrimaNota';
import PasspPrimaNota from './pages/PasspPrimaNota';
import PasspConti from './pages/PasspConti';
import PasspEsposizioneContabile from './pages/PasspEsposizioneContabile';
import PasspEsposizioneContabileDetail from './pages/PasspEsposizioneContabileDetail';
import PasspSituazioneContabile from './pages/PasspSituazioneContabile';
import Dossier from './pages/Dossier';
import DossierRecall from './pages/DossierRecall';
import DossierDetail from './pages/DossierDetail';
import Issuer from './pages/Issuer';
import IssuerDetail from './pages/IssuerDetail';
import Negotiation from './pages/Negotiation';
import Recessi from './pages/Recessi';
import PraticheUrgenzeOpposizioni from './pages/PraticheUrgenzeOpposizioni';
import CalendarioPraticheUO from './pages/CalendarioPraticheUO';
import PraticheMonitoraggio from './pages/PraticheMonitoraggio';
import MonitoraggioClienti from './pages/MonitoraggioClienti';
import PraticheCarichiLavoro from './pages/PraticheCarichiLavoro';
import PraticheCarichiContabile from './pages/PraticheCarichiContabile';
import PraticheReportSintesi from './pages/PraticheReportSintesi';
import PraticheKpiDashboard from './pages/PraticheKpiDashboard';
import NegotiationDetail from './pages/NegotiationDetail';
import Attivita from './pages/Attivita';
import AttivitaStatoIniziale from './pages/AttivitaStatoIniziale';
import AttivitaSvolta from './pages/AttivitaSvolta';
import AttivitaSvoltaDetails from './pages/AttivitaSvoltaDetails';
import AttivitaStatoFinale from './pages/AttivitaStatoFinale';
import AttivitaRegistro from './pages/AttivitaRegistro';
import AttivitaSintesiMensile from './pages/AttivitaSintesiMensile';
import TasksOverview from './pages/TasksOverview';
import ModulisticaList from './pages/modulistica/ModulisticaList';
import ModulisticaEdit from './pages/modulistica/ModulisticaEdit';
import CategorieModulistica from './pages/modulistica/CategorieModulistica';
import AttiAiTegmPage from './pages/AttiAiTegmPage';
import AttiAiIndicatoriTrimestraliPage from './pages/AttiAiIndicatoriTrimestraliPage';
import AttiAiTemplatePage from './pages/AttiAiTemplatePage';
import AttiAiPratichePage from './pages/AttiAiPratichePage';
import AttiAiGenerazioniDashboardPage from './pages/AttiAiGenerazioniDashboardPage';
import CloudTalkList from './pages/CloudTalk/CloudTalkList';
import CloudTalkKPI from './pages/CloudTalk/CloudTalkKPI';
import HrTitoliStudio from './pages/HrTitoliStudio';
import HrFonti from './pages/HrFonti';
import HrPosizioni from './pages/HrPosizioni';
import HrCandidati from './pages/HrCandidati';
import HrColloqui from './pages/HrColloqui';
import HrKpi from './pages/HrKpi';
import HrRisorseUmane from './pages/HrRisorseUmane';
import HrTimbra from './pages/HrTimbra';
import HrFeriePermessi from './pages/HrFeriePermessi';
import HrPresenze from './pages/HrPresenze';
import HrPresenzeMensili from './pages/HrPresenzeMensili';
import HrCedoliniCompensi from './pages/HrCedoliniCompensi';
import HrProfiliOrario from './pages/HrProfiliOrario';
import HrDipendenti from './pages/HrDipendenti';
import HrTipiAssenza from './pages/HrTipiAssenza';
import OpenBankingBusinessRegistry from './pages/OpenBankingBusinessRegistry';
import OpenBankingAccounts from './pages/OpenBankingAccounts';
import OpenBankingTransactions from './pages/OpenBankingTransactions';
import OpenBankingTransactionsCsv from './pages/OpenBankingTransactionsCsv';
import OpenBankingContabili from './pages/OpenBankingContabili';
import OpenBankingFlowProjection from './pages/OpenBankingFlowProjection';
import AiConversationsAdmin from './pages/AiConversationsAdmin';
import AiSettingsAdmin from './pages/AiSettingsAdmin';
import AiLlmModelsAdmin from './pages/AiLlmModelsAdmin';
import AiPromptsAdmin from './pages/AiPromptsAdmin';
import AiUsageAdmin from './pages/AiUsageAdmin';
import AiRequestsLogAdmin from './pages/AiRequestsLogAdmin';
import DocumentManagerPage from './pages/DocumentManagerPage';
import AnalisiNoteAI from './pages/AnalisiNoteAI';
import AnalisiTaskAI from './pages/AnalisiTaskAI';
import Assets from './pages/Assets';
import AssetDetail from './pages/AssetDetail';
import AssetEdit from './pages/AssetEdit';
import AssetCategories from './pages/AssetCategories';
import AssetSuppliers from './pages/AssetSuppliers';
import AssetCalendar from './pages/AssetCalendar';
import DataProtectionPolicy from './pages/DataProtectionPolicy';
import SpokiSettingsPage from './pages/SpokiSettingsPage';
import SpokiTemplatesPage from './pages/SpokiTemplatesPage';
import SpokiAutomationsPage from './pages/SpokiAutomationsPage';
import SpokiLogsPage from './pages/SpokiLogsPage';
import SpokiWebhooksPage from './pages/SpokiWebhooksPage';
import SpokiChatPage from './pages/SpokiChatPage';
import AdminSettings from './pages/AdminSettings';
import ScadenzarioPiani from './pages/ScadenzarioPiani';
import ScadenzarioRate from './pages/ScadenzarioRate';
import ScadenzarioInvioPromemoria from './pages/ScadenzarioInvioPromemoria';
import ScadenzarioKpiProiezionePiani from './pages/ScadenzarioKpiProiezionePiani';
import ScadenzarioKpiReferentiPiani from './pages/ScadenzarioKpiReferentiPiani';
import ScadenzarioKpiPerformanceReferenti from './pages/ScadenzarioKpiPerformanceReferenti';
import FunnelixPage from './pages/FunnelixPage';
import FunnelixKPI from './pages/FunnelixKPI';
import ParametriChiusure from './pages/ParametriChiusure';
import CommercialiChiusure from './pages/CommercialiChiusure';
import LegaliChiusure from './pages/LegaliChiusure';
import TransazioniCalcolo from './pages/TransazioniCalcolo';
import RichiesteDocumenti from './pages/RichiesteDocumenti';
import RichiesteDocumentiParametri from './pages/RichiesteDocumentiParametri';
import FasiGestione from './pages/FasiGestione';
import RegolePropostaModello from './pages/RegolePropostaModello';
import BlacklistTipiInadempienza from './pages/BlacklistTipiInadempienza';
import BlacklistSegnalazioni from './pages/BlacklistSegnalazioni';
import BlacklistRichiami from './pages/BlacklistRichiami';
import BlacklistKpi from './pages/BlacklistKpi';
import RecessiMotivazioni from './pages/RecessiMotivazioni';
import RecessiKpi from './pages/RecessiKpi';
import RecessiDocumenti from './pages/RecessiDocumenti';
import RecessoDetail from './pages/RecessoDetail';
import AderCodaValidazione from './pages/ader/AderCodaValidazione';
import AderDocumentoDetail from './pages/ader/AderDocumentoDetail';
import AderDocumentoUpload from './pages/ader/AderDocumentoUpload';
import AderReportAiAssistito from './pages/ader/AderReportAiAssistito';
import AderTipiDocumento from './pages/ader/AderTipiDocumento';
import ClaudePosizioneDebitoria from './pages/claude/ClaudePosizioneDebitoria';
import Sovraindebitamento from './pages/Sovraindebitamento';
import MonitoraggioSicCrif from './pages/MonitoraggioSicCrif';
import MonitoraggioSicCtc from './pages/MonitoraggioSicCtc';
import MonitoraggioSicCai from './pages/MonitoraggioSicCai';
import MonitoraggioSicUpsell from './pages/MonitoraggioSicUpsell';
import Agenda from './pages/Agenda';
import KpiLeadRegoleCalcoloPage from './pages/KpiLeadRegoleCalcoloPage';
import KpiLeadPage from './pages/KpiLeadPage';
import ChatWidget from './components/ChatWidget';

import {
  CreditCard as CreditCardIcon,
  ArrowLeftRight as ArrowLeftRightIcon,
  AlertCircle as AlertCircleIcon,
  BarChart3 as BarChart3Icon,
  ClipboardList as ClipboardListIcon,
  Boxes as BoxesIcon,
  FileText as FileTextIcon
} from 'lucide-react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return user ? children : <Navigate to="/login" />;
};

const AgencyOnlyPraticheFinanziarieGuard = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const roleName = (user?.role_name || user?.role || '').toLowerCase();
  const isAgency = roleName === 'agenzia';
  if (!isAgency) return children;

  const path = location.pathname || '/';
  const isAllowed =
    path === '/' ||
    path.startsWith('/pratiche-finanziarie') ||
    path === '/profile' ||
    path === '/data-protection' ||
    path === '/cessione-quinto' ||
    path === '/delega-pagamento';

  return isAllowed ? children : <Navigate to="/pratiche-finanziarie/pratiche" replace />;
};

const RequireAdmin = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  const roleName = (user?.role_name || user?.role || '').toLowerCase();
  const isAdmin = roleName === 'admin';
  return isAdmin ? children : <Navigate to="/" replace />;
};

const RequireAdminOrAgency = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  const roleName = (user?.role_name || user?.role || '').toLowerCase();
  const departmentName = (user?.department_name || '').toLowerCase();
  const isAdmin = roleName === 'admin';
  const isAgency = roleName === 'agenzia';
  const isAmministrazione =
    departmentName.includes('amministrazione') ||
    departmentName.includes('administration');
  return isAdmin || isAgency || isAmministrazione ? children : <Navigate to="/" replace />;
};

const RequireScadenzarioAccess = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  const roleName = (user?.role_name || user?.role || '').toLowerCase();
  const departmentName = (user?.department_name || '').toLowerCase();
  const canAccess =
    roleName === 'admin' ||
    roleName === 'call_pagamenti' ||
    departmentName.includes('amministrazione') ||
    departmentName.includes('administration');
  return canAccess ? children : <Navigate to="/" replace />;
};

const PlaceholderFeature = ({ title, subtitle, icon: Icon, items }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          {Icon ? (
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                bgcolor: '#eef2ff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Icon size={20} color="#4f46e5" />
            </Box>
          ) : null}
          <Box>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'text.primary' }}>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Card
        sx={{
          p: 3,
          borderRadius: 2,
          boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.2), 0 12px 24px -4px rgba(145, 158, 171, 0.12)'
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.25 }}>
          Roadmap
        </Typography>
        <Box component="ul" sx={{ pl: 3, m: 0 }}>
          {items.map((text) => (
            <Box component="li" key={text} sx={{ mb: 0.75 }}>
              <Typography variant="body1">{text}</Typography>
            </Box>
          ))}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Pagina predisposta. In attesa delle specifiche funzionali.
        </Typography>
      </Card>
    </Box>
  );
};
function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <MaintenanceProvider>
          <JobProvider>
            <SessionLockProvider>
              <Router>
                <MaintenanceGuard>
                  <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <AgencyOnlyPraticheFinanziarieGuard>
                    <Layout />
                  </AgencyOnlyPraticheFinanziarieGuard>
                </PrivateRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="quotes" element={<QuotesList />} />
              <Route path="quotes/new" element={<QuoteWizard />} />
              <Route path="companies" element={<Companies />} />
              <Route path="controparti" element={<Controparti />} />
              <Route path="users" element={<RequireAdmin><Users /></RequireAdmin>} />
              <Route path="roles" element={<RequireAdmin><Roles /></RequireAdmin>} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="contacts/:id" element={<ContactDetails />} />
              <Route path="locations" element={<Locations />} />
              <Route path="stati-pratica" element={<StatiPratica />} />
              <Route path="tipi-pratica" element={<TipiPratica />} />
              <Route path="tipi-pratica-azione" element={<TipiPraticaAzione />} />
              <Route path="tipi-azione" element={<Navigate to="/tipi-pratica-azione" replace />} />
              <Route path="tipi-atto" element={<TipiAtto />} />
              <Route path="tipi-posizione-credito" element={<TipiPosizioneCredito />} />
              <Route path="tipi-allegato-uo" element={<TipiAllegatoUO />} />
              <Route path="tipi-documento" element={<Navigate to="/tipi-atto" replace />} />
              <Route path="tipi-rapporto" element={<TipiRapporto />} />
              <Route path="tipi-evento" element={<TipiEvento />} />
              <Route path="jobs" element={<JobsMonitor />} />
              <Route path="db-monitor" element={<RequireAdmin><DbMonitor /></RequireAdmin>} />
              <Route path="fee-configs" element={<FeeConfigs />} />
              <Route path="fee-configs/new" element={<FeeConfigForm />} />
              <Route path="attivita" element={<Attivita />} />
              <Route path="attivita/registro" element={<AttivitaRegistro />} />
              <Route path="attivita/stato-iniziale" element={<AttivitaStatoIniziale />} />
              <Route path="attivita/attivita-svolta" element={<AttivitaSvolta />} />
              <Route path="attivita/attivita-svolta/:id" element={<AttivitaSvoltaDetails />} />
              <Route path="attivita/stato-finale" element={<AttivitaStatoFinale />} />
              <Route path="attivita/sintesi" element={<AttivitaSintesiMensile />} />
              <Route path="fee-configs/:id" element={<FeeConfigForm />} />
              <Route path="profile" element={<Profile />} />
              <Route path="email-accounts" element={<EmailAccounts />} />
              <Route path="email-accounts/:accountId/inbox" element={<EmailClient />} />
              <Route path="urgency" element={<Urgency />} />
              <Route path="tribunali" element={<Tribunali />} />
              <Route path="legali" element={<Legali />} />
              <Route path="esiti-udienza" element={<EsitiUdienza />} />
              <Route path="category-negotiation" element={<CategoryNegotiation />} />
              <Route path="category-negotiation/:id" element={<CategoryNegotiationDetail />} />
              <Route path="cluster" element={<Cluster />} />
              <Route path="cluster/:id" element={<ClusterDetail />} />
              <Route path="contatto" element={<Contatto />} />
              <Route path="debito-grant" element={<DebitoGrant />} />
              <Route path="debito-role" element={<DebitoRole />} />
              <Route path="department" element={<RequireAdmin><Department /></RequireAdmin>} />
              <Route path="office" element={<RequireAdmin><Office /></RequireAdmin>} />
              <Route path="app-departments" element={<RequireAdmin><AppDepartments /></RequireAdmin>} />
              <Route path="app-offices" element={<RequireAdmin><AppOffices /></RequireAdmin>} />
              <Route path="lorenzo-users" element={<LorenzoUsers />} />
              <Route path="customer" element={<Customer />} />
              <Route path="customer/cumulativa" element={<CustomerCumulative />} />
              <Route path="customer/:id" element={<CustomerDetail />} />
              <Route path="/risorseapipasspartout" element={<RisorseApiPasspartout />} />
              <Route path="/passp-clientes" element={<PasspClientes />} />
              <Route path="/passp-fatture" element={<PasspFatture />} />
              <Route path="/passp-fatture/stats" element={<PasspFattureStats />} />
              <Route path="/passp-controlli/fatture-vs-prima-nota" element={<PasspFattureVsPrimaNota />} />
              <Route path="/passp-prima-nota" element={<PasspPrimaNota />} />
              <Route path="/passp-conti" element={<PasspConti />} />
              <Route path="/passp-esposizione-contabile" element={<PasspEsposizioneContabile />} />
              <Route path="/passp-esposizione-contabile/:subjectKey" element={<PasspEsposizioneContabileDetail />} />
              <Route path="/passp-situazione-contabile" element={<PasspSituazioneContabile />} />
              <Route
                path="/scadenzario/piani"
                element={
                  <RequireScadenzarioAccess>
                    <ScadenzarioPiani />
                  </RequireScadenzarioAccess>
                }
              />
              <Route
                path="/scadenzario/rate"
                element={
                  <RequireScadenzarioAccess>
                    <ScadenzarioRate />
                  </RequireScadenzarioAccess>
                }
              />
              <Route
                path="/scadenzario/invio-promemoria"
                element={
                  <RequireScadenzarioAccess>
                    <ScadenzarioInvioPromemoria />
                  </RequireScadenzarioAccess>
                }
              />
              <Route
                path="/scadenzario/kpi/proiezione-piani"
                element={
                  <RequireScadenzarioAccess>
                    <ScadenzarioKpiProiezionePiani />
                  </RequireScadenzarioAccess>
                }
              />
              <Route
                path="/scadenzario/kpi/referenti-piani"
                element={
                  <RequireScadenzarioAccess>
                    <ScadenzarioKpiReferentiPiani />
                  </RequireScadenzarioAccess>
                }
              />
              <Route
                path="/scadenzario/kpi/performance-referenti"
                element={
                  <RequireScadenzarioAccess>
                    <ScadenzarioKpiPerformanceReferenti />
                  </RequireScadenzarioAccess>
                }
              />
              <Route
                path="cessione-quinto"
                element={<RequireAdminOrAgency><Navigate to="/pratiche-finanziarie/cessione-quinto" replace /></RequireAdminOrAgency>}
              />
              <Route
                path="delega-pagamento"
                element={<RequireAdminOrAgency><Navigate to="/pratiche-finanziarie/delega-pagamento" replace /></RequireAdminOrAgency>}
              />
              <Route
                path="pratiche-finanziarie/parametri"
                element={
                  <RequireAdminOrAgency>
                    <Navigate to="/pratiche-finanziarie/parametri/tipi-operazione" replace />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/parametri/tipi-operazione"
                element={
                  <RequireAdminOrAgency>
                    <PfTipiOperazione />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/parametri/stati-pratica"
                element={
                  <RequireAdminOrAgency>
                    <PfStatiPratica />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/parametri/tipi-documento"
                element={
                  <RequireAdminOrAgency>
                    <PfTipiDocumento />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/parametri/istituti-eroganti"
                element={
                  <RequireAdminOrAgency>
                    <PfIstitutiEroganti />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/pratiche/nuova"
                element={
                  <RequireAdminOrAgency>
                    <PfPraticaNew />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/pratiche/:id/modifica"
                element={
                  <RequireAdminOrAgency>
                    <PfPraticaEdit />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/pratiche/:id/documenti"
                element={
                  <RequireAdminOrAgency>
                    <PfPraticaDocumenti />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/pratiche/:id"
                element={
                  <RequireAdminOrAgency>
                    <PfPraticaDetail />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/pratiche"
                element={
                  <RequireAdminOrAgency>
                    <PfPratiche />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/clienti"
                element={
                  <RequireAdminOrAgency>
                    <PfClienti />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/documenti"
                element={
                  <RequireAdminOrAgency>
                    <Navigate to="/pratiche-finanziarie/pratiche" replace />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/alert"
                element={
                  <RequireAdminOrAgency>
                    <PlaceholderFeature
                      title="Pratiche Finanziarie — Alert"
                      subtitle="Sezione predisposta per alert, scadenze e anomalie delle pratiche finanziarie."
                      icon={AlertCircleIcon}
                      items={[
                        "Scadenze operative",
                        "Documenti mancanti",
                        "Anomalie rata/pagamenti",
                        "Notifiche e assegnazioni"
                      ]}
                    />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/cessione-quinto"
                element={
                  <RequireAdminOrAgency>
                    <PlaceholderFeature
                      title="Pratiche Finanziarie — Cessione del quinto"
                      subtitle="Sezione predisposta per la gestione delle pratiche finanziarie: cessione del quinto."
                      icon={CreditCardIcon}
                      items={[
                        "Anagrafica pratica (cliente, datore di lavoro, intermediari)",
                        "Documentazione e stato istruttoria",
                        "Dati economici (rata, durata, TAEG, montante)",
                        "Scadenze e promemoria operativi",
                        "Reportistica di base"
                      ]}
                    />
                  </RequireAdminOrAgency>
                }
              />
              <Route
                path="pratiche-finanziarie/delega-pagamento"
                element={
                  <RequireAdminOrAgency>
                    <PlaceholderFeature
                      title="Pratiche Finanziarie — Delega di pagamento"
                      subtitle="Sezione predisposta per la gestione delle pratiche finanziarie: delega di pagamento."
                      icon={ArrowLeftRightIcon}
                      items={[
                        "Anagrafica pratica (cliente, datore di lavoro, finanziaria)",
                        "Documentazione e workflow approvazioni",
                        "Parametri economici e condizioni",
                        "Monitoraggio rate/scadenze e anomalie",
                        "Reportistica di base"
                      ]}
                    />
                  </RequireAdminOrAgency>
                }
              />
              <Route path="dossier" element={<Dossier />} />
              <Route path="dossier/recall" element={<DossierRecall />} />
              <Route path="dossier/:id" element={<DossierDetail />} />
              <Route path="issuer" element={<Issuer />} />
              <Route path="issuer/:id" element={<IssuerDetail />} />
              <Route path="negotiation" element={<Negotiation />} />
              <Route path="recessi" element={<Recessi />} />
              <Route path="recessi/:id" element={<RecessoDetail />} />
              <Route
                path="recessi/kpi"
                element={
                  <RequireAdmin>
                    <RecessiKpi />
                  </RequireAdmin>
                }
              />
              <Route
                path="recessi/motivazioni"
                element={
                  <RequireAdmin>
                    <RecessiMotivazioni />
                  </RequireAdmin>
                }
              />
              <Route
                path="recessi/documenti"
                element={<RecessiDocumenti />}
              />
              <Route
                path="blacklist/kpi"
                element={
                  <RequireAdmin>
                    <BlacklistKpi />
                  </RequireAdmin>
                }
              />
              <Route
                path="blacklist/segnalazioni"
                element={<BlacklistSegnalazioni />}
              />
              <Route
                path="blacklist/tipi-inadempienza"
                element={
                  <RequireAdmin>
                    <BlacklistTipiInadempienza />
                  </RequireAdmin>
                }
              />
              <Route
                path="blacklist/richiami"
                element={
                  <RequireAdmin>
                    <BlacklistRichiami />
                  </RequireAdmin>
                }
              />
              <Route path="pratiche-urgenze-opposizioni" element={<PraticheUrgenzeOpposizioni />} />
              <Route path="pratiche-urgenze-opposizioni/calendario" element={<CalendarioPraticheUO />} />
              <Route path="pratiche" element={<Navigate to="/pratiche-urgenze-opposizioni" replace />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="appuntamenti-in-sede" element={<Navigate to="/agenda" replace />} />
              <Route path="pratiche-monitoraggio" element={<PraticheMonitoraggio />} />
              <Route path="clienti-monitoraggio" element={<MonitoraggioClienti />} />
              <Route
                path="pratiche-carichi-lavoro"
                element={
                  <RequireAdmin>
                    <PraticheCarichiLavoro />
                  </RequireAdmin>
                }
              />
              <Route
                path="pratiche-carichi-contabile"
                element={
                  <RequireAdmin>
                    <PraticheCarichiContabile />
                  </RequireAdmin>
                }
              />
              <Route path="pratiche-report" element={<PraticheReportSintesi />} />
              <Route path="pratiche-kpi" element={<PraticheKpiDashboard />} />
              <Route path="ader" element={<Navigate to="/ader/coda-validazione" replace />} />
              <Route path="ader/coda-validazione" element={<AderCodaValidazione />} />
              <Route path="ader/report-ai" element={<AderReportAiAssistito />} />
              <Route path="ader/documenti/upload" element={<AderDocumentoUpload />} />
              <Route path="ader/documenti/:id" element={<AderDocumentoDetail />} />
              <Route path="claude/posizione-debitoria" element={<ClaudePosizioneDebitoria />} />
              <Route
                path="ader/tipi-documento"
                element={
                  <RequireAdmin>
                    <AderTipiDocumento />
                  </RequireAdmin>
                }
              />
              <Route path="sovraindebitamento" element={<Sovraindebitamento />} />
              <Route path="sovraindebitamento/:sezione" element={<Sovraindebitamento />} />
              <Route path="monitoraggio-sic-cai/crif" element={<MonitoraggioSicCrif />} />
              <Route path="monitoraggio-sic-cai/ctc" element={<MonitoraggioSicCtc />} />
              <Route path="monitoraggio-sic-cai/cai" element={<MonitoraggioSicCai />} />
              <Route path="monitoraggio-sic-cai/upsell" element={<MonitoraggioSicUpsell />} />
              <Route
                path="analisi-note-ai"
                element={<AnalisiNoteAI />}
              />
              <Route
                path="analisi-task-ai"
                element={<AnalisiTaskAI />}
              />
              <Route path="modulistica/modelli" element={<ModulisticaList />} />
              <Route path="modulistica/modelli/new" element={<ModulisticaEdit />} />
              <Route path="modulistica/modelli/:id" element={<ModulisticaEdit />} />
              <Route path="modulistica/categorie" element={<CategorieModulistica />} />
              <Route path="atti-ai/tegm" element={<AttiAiTegmPage />} />
              <Route path="atti-ai/indicatori-trimestrali" element={<AttiAiIndicatoriTrimestraliPage />} />
              <Route path="atti-ai/template" element={<AttiAiTemplatePage />} />
              <Route path="atti-ai/pratiche" element={<AttiAiPratichePage />} />
              <Route path="atti-ai/dashboard-generazioni" element={<AttiAiGenerazioniDashboardPage />} />
              <Route path="negotiation/:id" element={<NegotiationDetail />} />
              <Route path="tasks" element={<TasksOverview />} />
              <Route path="cloudtalk" element={<CloudTalkList />} />
              <Route path="cloudtalk/kpi" element={<CloudTalkKPI />} />
              <Route path="crm/funnelix" element={<FunnelixPage />} />
              <Route path="crm/funnelix/kpi" element={<FunnelixKPI />} />
              <Route
                path="crm/lead-giornalieri/regole-calcolo"
                element={
                  <KpiLeadRegoleCalcoloPage />
                }
              />
              <Route
                path="crm/lead-giornalieri/kpi-lead"
                element={
                  <KpiLeadPage />
                }
              />
              <Route path="richieste/parametri" element={<RichiesteDocumentiParametri />} />
              <Route path="richieste/fasi-gestione" element={<FasiGestione />} />
              <Route path="richieste/regole-proposta-modello" element={<RegolePropostaModello />} />
              <Route path="chiusure/parametri_chiusure" element={<ParametriChiusure />} />
              <Route path="chiusure/commerciali_chiusure" element={<CommercialiChiusure />} />
              <Route path="chiusure/legali_chiusure" element={<LegaliChiusure />} />
              <Route path="chiusure/transazioni_calcolo" element={<TransazioniCalcolo />} />
              <Route path="chiusure/richieste-documenti" element={<RichiesteDocumenti />} />
              <Route path="hr/titoli-studio" element={<RequireAdmin><HrTitoliStudio /></RequireAdmin>} />
              <Route path="hr/fonti" element={<RequireAdmin><HrFonti /></RequireAdmin>} />
              <Route path="hr/posizioni" element={<RequireAdmin><HrPosizioni /></RequireAdmin>} />
              <Route path="hr/candidati" element={<RequireAdmin><HrCandidati /></RequireAdmin>} />
              <Route path="hr/colloqui" element={<RequireAdmin><HrColloqui /></RequireAdmin>} />
              <Route path="hr/kpi" element={<RequireAdmin><HrKpi /></RequireAdmin>} />
              <Route path="hr/risorse-umane" element={<HrRisorseUmane />} />
              <Route path="hr/timbra" element={<HrTimbra />} />
              <Route path="hr/ferie-permessi" element={<HrFeriePermessi />} />
              <Route path="hr/presenze" element={<HrPresenze />} />
              <Route path="hr/presenze-mensili" element={<RequireAdmin><HrPresenzeMensili /></RequireAdmin>} />
              <Route path="hr/cedolini-compensi" element={<HrCedoliniCompensi />} />
              <Route path="hr/profili-orario" element={<HrProfiliOrario />} />
              <Route path="hr/dipendenti" element={<HrDipendenti />} />
              <Route path="hr/tipi-assenza" element={<HrTipiAssenza />} />
              <Route path="open-banking/business-registry" element={<OpenBankingBusinessRegistry />} />
              <Route path="open-banking/accounts" element={<OpenBankingAccounts />} />
              <Route path="open-banking/transactions" element={<OpenBankingTransactions />} />
              <Route path="open-banking/transactions-csv" element={<OpenBankingTransactionsCsv />} />
              <Route path="open-banking/contabili" element={<OpenBankingContabili />} />
              <Route path="open-banking/flow-projection" element={<OpenBankingFlowProjection />} />
              <Route path="admin/settings" element={<RequireAdmin><AdminSettings /></RequireAdmin>} />
              <Route path="ai/conversations-admin" element={<RequireAdmin><AiConversationsAdmin /></RequireAdmin>} />
              <Route path="ai/settings" element={<RequireAdmin><AiSettingsAdmin /></RequireAdmin>} />
              <Route path="ai/llm-models" element={<RequireAdmin><AiLlmModelsAdmin /></RequireAdmin>} />
              <Route path="ai/prompts" element={<RequireAdmin><AiPromptsAdmin /></RequireAdmin>} />
              <Route path="ai/usage" element={<RequireAdmin><AiUsageAdmin /></RequireAdmin>} />
              <Route path="ai/logs" element={<RequireAdmin><AiRequestsLogAdmin /></RequireAdmin>} />
              <Route path="documenti" element={<DocumentManagerPage />} />
              <Route path="assets" element={<RequireAdmin><Assets /></RequireAdmin>} />
              <Route path="assets/new" element={<RequireAdmin><AssetEdit /></RequireAdmin>} />
              <Route path="assets/categories" element={<RequireAdmin><AssetCategories /></RequireAdmin>} />
              <Route path="assets/suppliers" element={<RequireAdmin><AssetSuppliers /></RequireAdmin>} />
              <Route path="assets/calendar" element={<RequireAdmin><AssetCalendar /></RequireAdmin>} />
              <Route path="assets/:id/edit" element={<RequireAdmin><AssetEdit /></RequireAdmin>} />
              <Route path="assets/:id" element={<RequireAdmin><AssetDetail /></RequireAdmin>} />
              <Route path="data-protection" element={<DataProtectionPolicy />} />
              <Route path="spoki/settings" element={<RequireAdmin><SpokiSettingsPage /></RequireAdmin>} />
              <Route path="spoki/templates" element={<RequireAdmin><SpokiTemplatesPage /></RequireAdmin>} />
              <Route path="spoki/automations" element={<RequireAdmin><SpokiAutomationsPage /></RequireAdmin>} />
              <Route path="spoki/logs" element={<RequireAdmin><SpokiLogsPage /></RequireAdmin>} />
              <Route path="spoki/webhooks" element={<RequireAdmin><SpokiWebhooksPage /></RequireAdmin>} />
              <Route path="spoki/chat" element={<SpokiChatPage />} />
            </Route>

            <Route path="*" element={<NotFound />} />
                  </Routes>
                </MaintenanceGuard>
                <ToastContainer />
                <ChatWidget />
              </Router>
            </SessionLockProvider>
          </JobProvider>
        </MaintenanceProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
